// Ключи Яндекс.Карт для страниц бизнес-центров. Раньше приходили через window._cianConfig из runtime settings
// YMAPS_URL, YMAPS_KEY_COMMERCIAL и YMAPS_SUGGEST_KEY_COMMERCIAL, переопределений в RS не было
export const YMAPS_URL = 'https://enterprise.api-maps.yandex.ru/2.1/?apikey=';
export const YMAPS_KEY = '9f42ecf6-47ce-4bea-b350-c56551c8fbac';
export const YMAPS_SUGGEST_KEY = '0b18e8db-9796-43ac-9734-2e27d922a46c';
export const YMAPS_URL_WITH_KEY = `${YMAPS_URL}${YMAPS_KEY}&suggest_apikey=${YMAPS_SUGGEST_KEY}`;

let ymapsPromise: Promise<IYmaps>;

export function loadYmapsApi(modules: string[], ymapsUrlWithKey: string): Promise<IYmaps> {
  if (!ymapsPromise) {
    ymapsPromise = new Promise((resolve, reject) => {
      if (window.ymaps) {
        resolve(window.ymaps);
        return;
      }

      const e = window.document.createElement('script');
      e.src = `${ymapsUrlWithKey}&lang=ru-RU&load=Map`;
      e.async = true;
      e.defer = true;
      e.onload = () => {
        window.ymaps.ready(() => {
          resolve(window.ymaps);
        });
      };
      e.onerror = () => {
        reject(new Error('Unable to load Yandex Maps API'));
      };
      window.document.body.appendChild(e);
    });
  }

  return ymapsPromise
    .then((ymaps) => {
      return new Promise((resolve, reject) => {
        ymaps.load(modules, () => {
          resolve(ymaps);
        }, reject);
      });
    });
}



// WEBPACK FOOTER //
// ./src/utils/ymaps.ts